export default "__VITE_ASSET__3ebf6561__"